export default {
  Success: 1,
  NotSuccess: 0,
};
